import React from "react";
import SideNav from "./SideNav";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import Footer from "./Footer";
import FooterPage from "./FooterPage";

function MenuLayout() {
  return (
    <>
      <CssBaseline />
      <Box sx={styles.container}>
        <Box>
          <SideNav />
        </Box>

        <Box component={"main"} sx={styles.mainSection} >
          <Outlet />
          <FooterPage />
        </Box>

      </Box>

    </>
  );
}

const styles = {
  container: {
    display: "flex",
    bgcolor: "neutral.light"
  },
  mainSection: {
    // paddingLeft: { xl: 6, lg: 6, md: 6, sm: 4, xs: 2 },
    // paddingRight: { xl: 4, lg: 4, md: 4, sm: 6, xs: 4 },
    // paddingTop: { xl: 4, lg: 4, md: 4, sm: 4, xs: 2 },
    // paddingBottom: { xl: 4, lg: 4, md: 4, sm: 4, xs: 2 },
    padding: { xl: 6, lg: 6, md: 4, sm: 4, xs: 2 },
    width: "100%",
    height: "100vh",
    overflow: "auto",
  },
};

export default MenuLayout;
